import { render } from "./BasketCard.vue?vue&type=template&id=2f6b1fb7"
import script from "./BasketCard.vue?vue&type=script&lang=js"
export * from "./BasketCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__